import { EnvelopeSimple, LinkedinLogo, InstagramLogo, TiktokLogo, WhatsappLogo } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { FadeIn } from "@/components/common/FadeIn";

const contactChannels = [
  { label: "Email", value: "contacto@pragmaticxxi.cl", href: "mailto:contacto@pragmaticxxi.cl" },
  { label: "Ubicación", value: "Santiago, Chile", href: "#contacto" },
  { label: "Horario", value: "Lunes a Viernes de 08:30 a 18:30", href: "#contacto" },
];

const socialLinks = [
  {
    id: "linkedin-pragmaticxxi",
    label: "LinkedIn PRAGMATICXXI",
    href: "https://www.linkedin.com/company/pragmaticxxi",
    icon: LinkedinLogo,
  },
  {
    id: "instagram-pragmaticxxi",
    label: "Instagram @pragmaticxxi.cl",
    href: "https://www.instagram.com/pragmaticxxi.cl",
    icon: InstagramLogo,
  },
  {
    id: "tiktok-pragmaticxxi",
    label: "TikTok @pragmaticxxi.cl",
    href: "https://www.tiktok.com/@pragmaticxxi.cl",
    icon: TiktokLogo,
  },
  {
    id: "whatsapp-pragmaticxxi",
    label: "WhatsApp +56973674899",
    href: "https://wa.me/56973674899?text=Hola.%20%C2%BFC%C3%B3mo%20podemos%20ayudarte%3F",
    icon: WhatsappLogo,
  },
];

export const Contact = () => {
  return (
    <section id="contacto" className="py-20 md:py-28" data-testid="contact-section">
      <div className="section-container grid gap-6 lg:grid-cols-2">
        <FadeIn>
          <article className="relative min-h-[540px] overflow-hidden border border-slate-200" data-testid="contact-image-panel">
            <img
              src="https://static.prod-images.emergentagent.com/jobs/ed9fba0f-d05c-45f9-a77a-3e8efa518b76/images/1be9bee3fc285f2aed3bd4e3af46ac7d02862de6b68f737a8ce78f9884f81319.png"
              alt="Equipo de trabajo conversando en reunión"
              className="h-full w-full object-cover object-center"
              data-testid="contact-panel-image"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-slate-900/20 via-slate-900/45 to-slate-900/90 p-8 md:p-10" data-testid="contact-image-overlay">
              <p className="text-xs uppercase tracking-[0.2em] text-slate-200" data-testid="contact-overlay-kicker">
                Hablemos
              </p>
              <h2 className="corporate-title-balance mt-4 text-4xl sm:text-5xl lg:text-6xl leading-[1.02] text-white" data-testid="contact-overlay-heading">
                Contacto directo y redes de la firma.
              </h2>
            </div>
          </article>
        </FadeIn>

        <FadeIn delay={0.12}>
          <article className="h-full border border-slate-200 bg-white p-8 md:p-10" data-testid="contact-details-panel">
            <p className="text-xs uppercase tracking-[0.2em] text-slate-500" data-testid="contact-details-kicker">
              Contacto
            </p>
            <h3 className="corporate-title-balance mt-3 text-base md:text-lg text-slate-700" data-testid="contact-details-subheading">
              Encuéntranos en nuestros canales para iniciar una conversación.
            </h3>

            <div className="mt-8 space-y-4 border-t border-slate-200 pt-6" data-testid="contact-channels-list">
              {contactChannels.map((channel) => (
                <a
                  key={channel.label}
                  href={channel.href}
                  className="flex items-start justify-between gap-3 border-b border-slate-100 py-3 transition-colors duration-300 hover:text-slate-950"
                  data-testid={`contact-channel-${channel.label.toLowerCase()}`}
                >
                  <span className="text-sm text-slate-500" data-testid={`contact-channel-label-${channel.label.toLowerCase()}`}>
                    {channel.label}
                  </span>
                  <span className="text-sm text-right text-slate-800" data-testid={`contact-channel-value-${channel.label.toLowerCase()}`}>
                    {channel.value}
                  </span>
                </a>
              ))}
            </div>

            <div className="mt-8" data-testid="contact-social-block">
              <p className="text-xs uppercase tracking-[0.2em] text-slate-500" data-testid="contact-social-heading">
                Redes
              </p>
              <div className="mt-4 flex flex-wrap gap-3" data-testid="contact-social-links">
                {socialLinks.map((social) => {
                  const Icon = social.icon;
                  return (
                    <a
                      key={social.label}
                      href={social.href}
                      target="_blank"
                      rel="noreferrer"
                      className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-[#B8C8D9] bg-white text-slate-700 transition-colors duration-300 hover:border-[#0077B6] hover:text-[#0077B6]"
                      data-testid={`social-link-${social.id}`}
                      aria-label={social.label}
                      title={social.label}
                    >
                      <Icon size={20} weight="regular" />
                    </a>
                  );
                })}
              </div>
            </div>

            <Button
              asChild
              className="mt-10 rounded-full bg-[#0077B6] px-6 text-xs uppercase tracking-[0.15em] text-white hover:bg-[#005F92]"
              data-testid="contact-email-cta-button"
            >
              <a href="mailto:contacto@pragmaticxxi.cl" data-testid="contact-email-cta-link">
                <EnvelopeSimple /> Escribir por email
              </a>
            </Button>
          </article>
        </FadeIn>
      </div>
    </section>
  );
};
